/*
 * Database API Generator is a utility library for Thunderstorm.
 *
 * Given proper configurations it will dynamically generate APIs to your Firestore
 * collections, will assert uniqueness and restrict deletion... and more
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { HttpMethod } from '../types.js';
export const DBApiDefGenerator = (dbDef) => {
    return {
        v1: {
            query: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/query` },
            queryUnique: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/query-unique` },
            upsert: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/upsert` },
            upsertAll: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/upsert-all` },
            patch: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/patch` },
            delete: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/delete-unique` },
            deleteQuery: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/delete` },
            deleteAll: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/delete-all` },
            metadata: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/metadata` },
        }
    };
};
export const DBApiDefGeneratorIDB = (dbDef) => {
    return {
        v1: {
            query: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/query` },
            queryUnique: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/query-unique` },
            upsert: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/upsert` },
            upsertAll: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/upsert-all` },
            patch: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/patch` },
            delete: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/delete-unique` },
            deleteQuery: { method: HttpMethod.POST, path: `v1/${dbDef.dbKey}/delete` },
            deleteAll: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/delete-all` },
            metadata: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/metadata` },
        }
    };
};
//# sourceMappingURL=apiV1.js.map